import { REQUEST, FAILURE, SUCCESS, action, createRequestTypes } from 'redux-config/reduxHelpers';

export const GET_ANNOUNCEMENTS_LIST = createRequestTypes('GET_ANNOUNCEMENTS_LIST');
export const getAnnouncementsList = {
  request: () => action(GET_ANNOUNCEMENTS_LIST[REQUEST]),
  success: data => action(GET_ANNOUNCEMENTS_LIST[SUCCESS], { data }),
  failure: error => action(GET_ANNOUNCEMENTS_LIST[FAILURE], { error }),
};

export const GET_ANNOUNCEMENT_DETAIL = createRequestTypes('GET_ANNOUNCEMENT_DETAIL');
export const getAnnouncementDetail = {
  request: id => action(GET_ANNOUNCEMENT_DETAIL[REQUEST], { id }),
  success: data => action(GET_ANNOUNCEMENT_DETAIL[SUCCESS], { data }),
  failure: error => action(GET_ANNOUNCEMENT_DETAIL[FAILURE], { error }),
};

export const CREATE_ANNOUNCEMENT = createRequestTypes('CREATE_ANNOUNCEMENT');
export const createAnnouncement = {
  request: data => action(CREATE_ANNOUNCEMENT[REQUEST], data),
  success: data => action(CREATE_ANNOUNCEMENT[SUCCESS], { data }),
  failure: error => action(CREATE_ANNOUNCEMENT[FAILURE], { error }),
};

export const UPDATE_ANNOUNCEMENT = createRequestTypes('UPDATE_ANNOUNCEMENT');
export const updateAnnouncement = {
  request: (id, data) => action(UPDATE_ANNOUNCEMENT[REQUEST], { id, data }),
  success: data => action(UPDATE_ANNOUNCEMENT[SUCCESS], { data }),
  failure: error => action(UPDATE_ANNOUNCEMENT[FAILURE], { error }),
};

export const DELETE_ANNOUNCEMENT = createRequestTypes('DELETE_ANNOUNCEMENT');
export const deleteAnnouncement = {
  request: id => action(DELETE_ANNOUNCEMENT[REQUEST], { id }),
  success: () => action(DELETE_ANNOUNCEMENT[SUCCESS]),
  failure: error => action(DELETE_ANNOUNCEMENT[FAILURE], { error }),
};

export const TOGGLE_ANNOUNCEMENT = createRequestTypes('TOGGLE_ANNOUNCEMENT');
export const toggleAnnouncement = {
  request: id => action(TOGGLE_ANNOUNCEMENT[REQUEST], { id }),
  success: data => action(TOGGLE_ANNOUNCEMENT[SUCCESS], { data }),
  failure: error => action(TOGGLE_ANNOUNCEMENT[FAILURE], { error }),
};
